import { render, staticRenderFns } from "./ContentFilterTags.vue?vue&type=template&id=66a95439&scoped=true&"
import script from "./ContentFilterTags.vue?vue&type=script&lang=js&"
export * from "./ContentFilterTags.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilterTags.vue?vue&type=style&index=0&id=66a95439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a95439",
  null
  
)

export default component.exports